import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import { ImportPayload } from "src/app/_models/Import/ImportModel";
import { ImportExternalResultsActionTypes } from "src/app/constants/StoreConstants";
import { ImportStatus } from "../import/import.state";

export const UploadExternalResultsCSV = createAction(
  ImportExternalResultsActionTypes.UploadExternalResultsCSV,
  props<{payload: ImportPayload}>()
);

export const UploadExternalResultsCSVSuccess = createAction(
  ImportExternalResultsActionTypes.UploadExternalResultsCSVSuccess,
  props<{result: boolean}>()
);

export const UploadExternalResultsCSVError = createAction(
  ImportExternalResultsActionTypes.UploadExternalResultsCSVError,
  props<{error: HttpErrorResponse}>()
);

export const GetExternalResultsImportStatusSuccess = createAction(
  ImportExternalResultsActionTypes.GetExternalResultsImportStatusSuccess,
  props<{result: ImportStatus}>()
);

export const GetExternalResultsImportStatusError = createAction(
  ImportExternalResultsActionTypes.GetExternalResultsImportStatusError,
  props<{error: HttpErrorResponse}>()
);

export const AuthorizeImportExternalResultsSSE = createAction(
  ImportExternalResultsActionTypes.AuthorizeImportExternalResultsSSE
);

export const AuthorizeImportExternalResultsSSESuccess = createAction(
  ImportExternalResultsActionTypes.AuthorizeImportExternalResultsSSESuccess,
  props<{result: boolean}>()
);

export const AuthorizeImportExternalResultsSSEError = createAction(
  ImportExternalResultsActionTypes.AuthorizeImportExternalResultsSSEError,
  props<{error: HttpErrorResponse}>()
);0

export const HasImportedExternalResults = createAction(
  ImportExternalResultsActionTypes.HasImportedExternalResults
);

export const HasImportedExternalResultsSuccess = createAction(
  ImportExternalResultsActionTypes.HasImportedExternalResultsSuccess,
  props<{result: number}>()
);

export const HasImportedExternalResultsError = createAction(
  ImportExternalResultsActionTypes.HasImportedExternalResultsError,
  props<{error: HttpErrorResponse}>()
);

export const DownloadExternalResultsImportErrorList = createAction(
  ImportExternalResultsActionTypes.DownloadExternalResultsImportErrorList
);

export const DownloadExternalResultsImportErrorListSuccess = createAction(
  ImportExternalResultsActionTypes.DownloadExternalResultsImportErrorListSuccess,
  props<{result: string[]}>()
);

export const DownloadExternalResultsImportErrorListError = createAction(
  ImportExternalResultsActionTypes.DownloadExternalResultsImportErrorListError,
  props<{error: HttpErrorResponse}>()
);

export const CancelExternalResultsImport = createAction(
  ImportExternalResultsActionTypes.CancelExternalResultsImport
);

export const CancelExternalResultsImportSuccess = createAction(
  ImportExternalResultsActionTypes.CancelExternalResultsImportSuccess
);

export const CancelExternalResultsImportError = createAction(
  ImportExternalResultsActionTypes.CancelExternalResultsImportError
);

export const ClearExternalResultsImportSession = createAction(
  ImportExternalResultsActionTypes.ClearExternalResultsImportSession
);

export const ClearExternalResultsImportSessionSuccess = createAction(
  ImportExternalResultsActionTypes.ClearExternalResultsImportSessionSuccess
);

export const ClearExternalResultsImportSessionResult = createAction(
  ImportExternalResultsActionTypes.ClearExternalResultsImportSessionResult,
  props<{result: boolean}>()
);

export const CloseImportExternalResultsStatus = createAction(
  ImportExternalResultsActionTypes.CloseImportExternalResultsStatus
);

export const ResetExternalResultsImportState = createAction(
  ImportExternalResultsActionTypes.ResetExternalResultsImportStatus
);